import { EMPTY_STRING, ZERO } from './constants';

const TAIL = 4;
const MAX_ADDRESS_LENGTH = 12;

const cropAddress = (address: string): string => {
  const parts = address.split('.');
  const domain = parts.pop() || EMPTY_STRING;

  if (parts.length === ZERO) {
    return address.length > MAX_ADDRESS_LENGTH ? `${address.substring(ZERO, TAIL)}...${address.slice(-TAIL)}` : address;
  }

  const joined = parts.join('.');
  return joined.length > MAX_ADDRESS_LENGTH ? `${joined.substring(ZERO, TAIL)}...${joined.slice(-TAIL)}.${domain}` : address;
};

export default cropAddress;
